import React from "react";

const IconSecurity = () => {
  return (
    <svg
      width="48"
      height="49"
      viewBox="0 0 48 49"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect y="0.463867" width="48" height="48" rx="24" fill="#006F94" />
      <path
        d="M25.0962 19.4446H10.0275C9.425 19.4446 8.93658 19.933 8.93658 20.5355V34.4931C8.93658 35.0955 9.425 35.584 10.0275 35.584H25.0962"
        stroke="white"
        stroke-width="1.27636"
      />
      <path
        d="M22.9241 19.4443L22.9241 15.1403C22.9241 13.5817 21.6044 12.3069 19.9912 12.3069H17.2509C15.6376 12.3069 14.3164 13.5817 14.3164 15.1403L14.3164 19.4443"
        stroke="white"
        stroke-width="1.27636"
      />
      <circle
        cx="33.3683"
        cy="17.9701"
        r="1.61394"
        stroke="white"
        stroke-width="1.27636"
        stroke-linecap="round"
      />
      <circle
        cx="37.4494"
        cy="23.1718"
        r="1.61394"
        stroke="white"
        stroke-width="1.27636"
        stroke-linecap="round"
      />
      <circle
        cx="35.2974"
        cy="29.0895"
        r="1.61394"
        stroke="white"
        stroke-width="1.27636"
        stroke-linecap="round"
      />
      <circle
        cx="30.9938"
        cy="35.0072"
        r="1.61394"
        stroke="white"
        stroke-width="1.27636"
        stroke-linecap="round"
      />
      <path
        d="M22.9242 22.6339H28.8419L32.0698 19.406"
        stroke="white"
        stroke-width="1.27636"
      />
      <path
        d="M22.9242 25.8618H30.4559L33.1458 23.1719H35.8357"
        stroke="white"
        stroke-width="1.27636"
      />
      <path
        d="M22.9242 29.0896H33.6838"
        stroke="white"
        stroke-width="1.27636"
      />
      <path
        d="M22.9242 32.3176H28.304L29.9179 33.9316"
        stroke="white"
        stroke-width="1.27636"
      />
      <mask
        id="path-12-outside-1_72_1447"
        maskUnits="userSpaceOnUse"
        x="14.6489"
        y="22.2288"
        width="8"
        height="10"
        fill="black"
      >
        <rect fill="white" x="14.6489" y="22.2288" width="8" height="10" />
        <path d="M18.6206 24.2288C19.7091 24.229 20.5913 25.1119 20.5913 26.2004C20.5911 27.058 20.0426 27.7849 19.2778 28.0559V30.2542C19.2777 30.5553 19.0331 30.7991 18.7319 30.7991H18.5093C18.2081 30.7991 17.9635 30.5553 17.9634 30.2542V28.0559C17.1983 27.7851 16.6491 27.0582 16.6489 26.2004C16.6489 25.1118 17.5319 24.2288 18.6206 24.2288Z" />
      </mask>
      <path
        d="M18.6206 24.2288L18.6208 22.9524H18.6206V24.2288ZM20.5913 26.2004L21.8677 26.2007V26.2004H20.5913ZM19.2778 28.0559L18.8515 26.8528L18.0015 27.1541V28.0559H19.2778ZM19.2778 30.2542L20.5542 30.2547V30.2542H19.2778ZM17.9634 30.2542H16.687L16.687 30.2547L17.9634 30.2542ZM17.9634 28.0559H19.2397V27.1537L18.3892 26.8527L17.9634 28.0559ZM16.6489 26.2004H15.3726V26.2007L16.6489 26.2004ZM18.6206 24.2288L18.6204 25.5051C19.0036 25.5052 19.3149 25.8162 19.3149 26.2004H20.5913H21.8677C21.8677 24.4076 20.4147 22.9527 18.6208 22.9524L18.6206 24.2288ZM20.5913 26.2004L19.3149 26.2002C19.3149 26.4976 19.1256 26.7557 18.8515 26.8528L19.2778 28.0559L19.7041 29.259C20.9596 28.8141 21.8674 27.6184 21.8677 26.2007L20.5913 26.2004ZM19.2778 28.0559H18.0015V30.2542H19.2778H20.5542V28.0559H19.2778ZM19.2778 30.2542L18.0015 30.2536C18.0016 29.8478 18.3306 29.5227 18.7319 29.5227V30.7991V32.0754C19.7356 32.0754 20.5537 31.2627 20.5542 30.2547L19.2778 30.2542ZM18.7319 30.7991V29.5227H18.5093V30.7991V32.0754H18.7319V30.7991ZM18.5093 30.7991V29.5227C18.9106 29.5227 19.2396 29.8478 19.2397 30.2536L17.9634 30.2542L16.687 30.2547C16.6875 31.2627 17.5056 32.0754 18.5093 32.0754V30.7991ZM17.9634 30.2542H19.2397V28.0559H17.9634H16.687V30.2542H17.9634ZM17.9634 28.0559L18.3892 26.8527C18.1146 26.7555 17.9254 26.4972 17.9253 26.2002L16.6489 26.2004L15.3726 26.2007C15.3729 27.6193 16.282 28.8148 17.5375 29.2591L17.9634 28.0559ZM16.6489 26.2004H17.9253C17.9253 25.8167 18.2368 25.5051 18.6206 25.5051V24.2288V22.9524C16.827 22.9524 15.3726 24.4068 15.3726 26.2004H16.6489Z"
        fill="white"
        mask="url(#path-12-outside-1_72_1447)"
      />
    </svg>
  );
};

export default IconSecurity;
